<template>
    <div>
        <div id="polygonalChart" :style="{width: '1120px', height: '550px'}"></div>
    </div>
</template>

<script>
import { defineComponent, onBeforeUnmount, ref } from "vue";
import { useI18n } from "@/i18nPlugin";
import * as echarts from 'echarts'
import { 
    getPolygonalDayData,
    getPolygonalMonthData
} from '../../api/index';
var moment = require('moment')
export default defineComponent({
    props: {
        watchData: Object
    },
    setup() {
        const i18n = useI18n();
        const token = localStorage.getItem("userToken");
        const getPolygonalChart = (n) => {
            if(n.tag == 'day') {
                getPolygonalDayData({
                    startTime: n.dayStart ? moment(n.dayStart).format("YYYY-MM-DD") : n.dayStart,
                    endTime: n.dayEnd ? moment(n.dayEnd).format("YYYY-MM-DD") : n.dayEnd
                },token).then(res => {
                    legendData.value = res.data.legendData
                    seriesData.value = res.data.seriesDatas
                    xAxisData.value = res.data.xAxisData
                    showCharts();
                    console.log(res.data)
                }).catch(error => {
                    console.log(error)
                });
            }else if(n.tag == 'month'){
                getPolygonalMonthData({
                    startTime: n.monthStart ? moment(n.monthStart).format("YYYY-MM-DD") : n.monthStart,
                    endTime: n.monthEnd ? moment(n.monthEnd).format("YYYY-MM-DD") : n.monthEnd
                },token).then(res => {
                    legendData.value = res.data.legendData
                    seriesData.value = res.data.seriesDatas
                    xAxisData.value = res.data.xAxisData
                    showCharts();
                    console.log(res.data)
                }).catch(error => {
                    console.log(error)
                });
            }
        }
        const legendData = ref([])
        const seriesData = ref([])
        const xAxisData = ref([])
        const myChart = ref(null);
        const showCharts = ()=> {
            // 绘制图表
            let myChartTemp = echarts.init(document.getElementById("polygonalChart"))
            myChartTemp.setOption({
                // title: {
                //     text: '访问量'
                // },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: legendData.value
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true
                },
                dataZoom: [{
                    "show": true,
                    "height": 30,
                    "xAxisIndex": [
                        0
                    ],
                    bottom: 15,
                    "start": 0,
                    "end": 100,
                    handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
                    handleSize: '110%',
                    handleStyle:{
                        color:"#d3dee5",
                        
                    },
                    borderColor:"#90979c"
                }, {
                    "type": "inside",
                    "show": true,
                    "height": 15,
                    "start": 1,
                    "end": 35
                }],
                toolbox: {
                    feature: {
                    saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xAxisData.value
                },
                yAxis: {
                    type: 'value'
                },
                series: seriesData.value
            });
            myChart.value = myChartTemp
        };
        onBeforeUnmount(()=>{
            myChart.value.dispose();
        } )
        return {
            i18n,
            seriesData,
            legendData,
            xAxisData,
            getPolygonalChart,
            showCharts,
            myChart
        }
    },
    watch:{ 
        watchData:{
            handler(n,o){
                this.getPolygonalChart(n);
                // console.log(n.tag)
                // console.log(n.monthStart ? moment(n.monthStart).startOf("month").format("YYYY-MM-DD") : n.monthStart)
                // console.log(n.monthEnd ? moment(n.monthEnd).endOf('month').format("YYYY-MM-DD") : n.monthEnd)
                // console.log(n.dayStart ? moment(n.dayStart).format('YYYY-MM-DD') : n.dayStart)
                // console.log(n.dayEnd ? moment(n.dayEnd).format('YYYY-MM-DD') : n.dayEnd)
            },
            deep:true
        }
    }
})
</script>
    
<style scoped>
    
</style>